import getUrlBase from "datastore/getUrlBase";
import paramsToQs from "util/paramsToQs";

import postUnsafe from "./postUnsafe";

/* Params is object, we'll write key, value pairs to the url */
export default async function post(url, params) {
  let response;
  try {
    response = await postUnsafe(url, params);
  } catch (error) {}
  return response;
}
